export enum RumEvent {
  GRAPHQL_ERROR = 'graphql_error',
  NETWORK_ERROR = 'network_error',
  ERROR_BOUNDARY = 'error_boundary',
  UNHANDLED_REJECTION = 'unhandled_rejection',
  GLOBAL_ERROR = 'global_error',
  SSO_CONFIG_INVALID = 'sso_config_invalid',
}
